<template>
    <div class="text-center"  :dark="$store.getters.getColorPalette().isDark" >
        <!-- class="devc"  -->
        <v-btn text small outlined :dark="$store.getters.getColorPalette().isDark" :background-color="$store.getters.getColorPalette().background1ColorCode" :color="$store.getters.getColorPalette().accentCode" @click="dialog = !dialog">
           {{ $store.getters.getTextMap().create_data_logger }} <v-icon right :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().btnborderColorCode">mdi-clipboard-text-outline</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card  :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().backgroundColorCode">
                <v-toolbar :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().foregroundColorCode">
                    <v-btn icon :dark="$store.getters.getColorPalette().isDark" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                    <v-toolbar-title> {{ $store.getters.getTextMap().data_log }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn :dark="$store.getters.getColorPalette().isDark" text @click="dialog = false">close</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <CreateDataLog v-on:close="dialog=false"/>
            </v-card>
      </v-dialog>
    </div>
</template>
<script>
  import CreateDataLog from '@/components/crud_components/CreateDataLog'
  export default {
      name:'CreateDataLogBottomSheet',
      components:{
        CreateDataLog  
      },
      data(){
          return {
              dialog:false
          }
      },
      methods:{
          
      }
  }
  </script>
  <style scoped>
  .devc{
     border:3px solid;
    border-radius:20px;
  
  }
  
  </style>